import React, { useEffect, useState } from "react";
import { Tab, TabList, Tabs } from "react-tabs";
import Modal from "react-modal";
import { useGetFetchNew } from "../../../data/Queries";
import { top_users } from "../../../data/ApiEndpoints";
import { convertThenFormat } from "../../../components/common-data/Converts";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import TopUserDetail from "./TopUserDetail";

const TopUsers = ({ userInfoData, gymId }) => {
  const [activeTab, setActiveTab] = useState("");
  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(8);

  const [selectedUser, setSelectedUser] = useState(null);

  // Fetch Data with Filters
  const { data, isLoading, refetch } = useGetFetchNew({
    token: userInfoData?.token,
    key: "top_users",
    url: `${top_users}`,
    filters: {
      limit: pageLimit,
      gym_id: gymId || "",
      page: page + 1,
    },
  });

  useEffect(() => {
    refetch();
  }, [activeTab, page, pageLimit, gymId]);

  const tbColumns = [
    {
      dataField: "name",
      text: <p className="table__header">Name</p>,
      formatter: (cell, row) => {
        return (
          <p
            onClick={() => setSelectedUser(row)}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
          >
            {row?.name}
          </p>
        );
      },
    },
    {
      dataField: "gym_name",
      text: <p className="table__header">Gym Name</p>,
      formatter: (cell, row) => {
        return <p>{row?.gym_name}</p>;
      },
    },
    {
      dataField: "total_spent",
      text: <p className="table__header">Total Coins Spent</p>,
      formatter: (cell, row) => {
        return (
          <div>
            <p
              style={{
                fontSize: "18px",
              }}
            >
              {row?.total_spent}
            </p>
            <p>{`₹${convertThenFormat(row?.total_spent_inr_value)}`}</p>
          </div>
        );
      },
    },
    {
      dataField: "total_earn",
      text: <p className="table__header">Total Coins Earned</p>,
      formatter: (cell, row) => {
        return (
          <div>
            <p
              style={{
                fontSize: "18px",
              }}
            >
              {row?.total_earn}
            </p>
            <p>{`₹${convertThenFormat(row?.total_earn_inr_value)}`}</p>
          </div>
        );
      },
    },
  ];

  const tbColumnNonMember = [
    {
      dataField: "name",
      text: <p className="table__header">Name</p>,
      formatter: (cell, row) => {
        return (
          <p
            onClick={() => setSelectedUser(row)}
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
          >
            {row?.name}
          </p>
        );
      },
    },
    {
      dataField: "total_spent",
      text: <p className="table__header">Total Coins Spent</p>,
      formatter: (cell, row) => {
        return (
          <div>
            <p
              style={{
                fontSize: "18px",
              }}
            >
              {row?.total_spent}
            </p>
            <p>{`₹${convertThenFormat(row?.total_spent_inr_value)}`}</p>
          </div>
        );
      },
    },
    {
      dataField: "total_earn",
      text: <p className="table__header">Total Coins Earned</p>,
      formatter: (cell, row) => {
        return (
          <div>
            <p
              style={{
                fontSize: "18px",
              }}
            >
              {row?.total_earn}
            </p>
            <p>{`₹${convertThenFormat(row?.total_earn_inr_value)}`}</p>
          </div>
        );
      },
    },
  ];

  return (
    <div className="allEarningTask">
      <div className="flex-container">
        <h4>Top Users</h4>

        <div className="tab__Border">
          <Tabs
            selectedIndex={
              activeTab === "" ? 0 : activeTab === "member" ? 1 : 2
            }
            onSelect={(index) =>
              setActiveTab(
                index === 0 ? "" : index === 1 ? "member" : "non_member"
              )
            }
          >
            <TabList
              style={{
                display: "flex",
                margin: 0,
                padding: 0,
              }}
            >
              <Tab>All-Members</Tab>
              <Tab>Member</Tab>
              <Tab>Non-Member</Tab>
            </TabList>
          </Tabs>
        </div>
      </div>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        <PaymentLinkTable
          tableData={data?.data}
          tableColumns={
            activeTab === "non_member" ? tbColumnNonMember : tbColumns
          }
          userInfoData={userInfoData}
          isPage={page}
          setIsPage={(value) => setPage(value)}
          isLoading={isLoading}
          tablePagination={data?.pagination}
          setPageLimit={setPageLimit}
          pageLimit={pageLimit}
        />
      </div>

      <Modal
        isOpen={selectedUser != null}
        contentLabel="User Reward Details"
        ariaHideApp={false}
        onRequestClose={() => setSelectedUser(null)}
      >
        <TopUserDetail
          closeModal={() => setSelectedUser(null)}
          selectedUser={selectedUser}
          userInfoData={userInfoData}
          gymId={gymId}
        />
      </Modal>
    </div>
  );
};

export default TopUsers;
